import { Routes } from '@angular/router';
import { checklisteRoutes } from '@softapps/allgemein/checkliste';
import { loginRoutes } from '@softapps/allgemein/login';
import { moduleRoutes } from '@softapps/allgemein/modules';
import { passwordRoutes } from '@softapps/allgemein/password';
import { settingsRoutes } from '@softapps/allgemein/utils';
import { constructionPartsRoutes } from '@softapps/gewerbe/construction-parts';
import { artikelvorratRoutes } from '@softapps/mde/artikelvorrat';
import { bestellerfassungRoutes } from '@softapps/mde/bestellerfassung';
import { bestellvorschlagRoutes } from '@softapps/mde/bestellvorschlag';
import { etikettendruckRoutes } from '@softapps/mde/etikettendruck';
import { lagerInventurRoutes } from '@softapps/mde/inventur';
import { materiallieferscheinScanRoutes } from '@softapps/mde/materiallieferschein-scan';
import { retourenRoutes } from '@softapps/mde/retouren';
import { warenverprobungRoutes } from '@softapps/mde/warenverprobung';
import { orderRoutes } from '@softapps/werkstatt/order';
import { artikelInfoRoutes } from '@softapps/wws/artikel-info';
import { warenuebernahmeRoutes } from '@softapps/wws/warenuebernahme';
import { lieferscheinRoutes } from '@softapps/wws/lieferschein';
import { energietransportRoutes } from '@softapps/wws/energietransport';

export const shellRoutes: Routes = [
  //Allgemein
  ...moduleRoutes,
  ...settingsRoutes,

  //Wws
  // ...gesamtabfrageRoutes,
  // ...stempelerfassungRoutes,

  // MDE
  ...bestellvorschlagRoutes,
  ...bestellerfassungRoutes,
  ...etikettendruckRoutes,
  ...lagerInventurRoutes,
  ...retourenRoutes,
  ...warenverprobungRoutes,
  ...artikelInfoRoutes,
  ...artikelvorratRoutes,
  ...materiallieferscheinScanRoutes,
  ...checklisteRoutes,

  ...warenuebernahmeRoutes,
  ...lieferscheinRoutes,
  ...energietransportRoutes,

  ...orderRoutes,
];

export const publicRoutes: Routes = [
  ...loginRoutes,
  ...passwordRoutes,
  ...settingsRoutes,
];

/*
export const routes: Routes = [
  {
    path: '',
    loadComponent: () => import('@softapps/core').then((o) => o.ShellComponent),
    children: [
      //Allgemein
      ...moduleRoutes,
      ...settingsRoutes,

      //Wws
      // ...gesamtabfrageRoutes,
      // ...stempelerfassungRoutes,

      // MDE
      ...bestellvorschlagRoutes,
      ...bestellerfassungRoutes,
      ...etikettendruckRoutes,
      ...lagerInventurRoutes,
      ...retourenRoutes,
      ...warenverprobungRoutes,
      ...artikelInfoRoutes,
      ...artikelvorratRoutes,
      ...materiallieferscheinScanRoutes,
      ...checklisteRoutes,

      ...constructionPartsRoutes,

      ...garageAuftragRoutes,
    ],
    canActivate: [AuthenticationGuard],
  },
  {
    path: '',
    loadComponent: () => import('@softapps/core').then((o) => o.PublicShellComponent),
    children: [...loginRoutes, ...passwordRoutes, ...settingsRoutes],
  },
];
*/
